/**
 * @generated SignedSource<<8920f3e0608839c8ec948a68489df296>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCard_user$data = {
  readonly backgroundPhoto: {
    readonly id: string;
  } | null | undefined;
  readonly bio: string | null | undefined;
  readonly editorGuildMemberships: {
    readonly " $fragmentSpreads": FragmentRefs<"UserCard_GuildMembershipBadgesFragment">;
  };
  readonly firstName: string;
  readonly id: string;
  readonly isFollowing: boolean | null | undefined;
  readonly isMe: boolean | null | undefined;
  readonly lastName: string;
  readonly organizerGuildMemberships: {
    readonly " $fragmentSpreads": FragmentRefs<"UserCard_GuildMembershipBadgesFragment">;
  };
  readonly rowId: string;
  readonly slugId: string;
  readonly " $fragmentSpreads": FragmentRefs<"UserBackgroundPhoto_user" | "UserFollowingStatus_user" | "UserPrimaryPhoto_user">;
  readonly " $fragmentType": "UserCard_user";
};
export type UserCard_user$key = {
  readonly " $data"?: UserCard_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCard_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "UserCard_GuildMembershipBadgesFragment"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCard_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMe",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFollowing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "backgroundPhoto",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserFollowingStatus_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserPrimaryPhoto_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserBackgroundPhoto_user"
    },
    {
      "alias": "organizerGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "ORGANIZER"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"ORGANIZER\"},first:3)"
    },
    {
      "alias": "editorGuildMemberships",
      "args": [
        {
          "kind": "Literal",
          "name": "condition",
          "value": {
            "membershipLevel": "EDITOR"
          }
        },
        (v1/*: any*/)
      ],
      "concreteType": "GuildMembershipsConnection",
      "kind": "LinkedField",
      "name": "guildMemberships",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": "guildMemberships(condition:{\"membershipLevel\":\"EDITOR\"},first:3)"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8374b412b4dd10a66fee803c72125adb";

export default node;
